<template>
  <div class="layout olap" :data-code="code">
    <loader v-if="loading" :active="loading" label="Данные загружаются" :height="400" />

    <div v-else-if="noReportError">
      <c-button
        size="small"
        label="К списку отчетов"
        :icon="{
          icon: 'back',
        }"
        @click="$router.push({ name: 'olap', query: { code: code } })"
      />

      <div class="no-report">Отчет не найден</div>
    </div>

    <template v-else>
      <m-confirm ref="confirmModal" mode="danger" />
      <m-highlight-data-modal :active="isShowHighlightDataModal" @close="isShowHighlightDataModal = false" />
      <m-save-olap-report
        :code="code"
        :active="isShowSaveOlapReportModal"
        :name-report="reportName"
        @close="isShowSaveOlapReportModal = false"
        @save="save"
      />
      <m-report ref="reportModal" :code="code" @updated="onReportUpdated" @removed="onReportRemoved" />
      <m-description ref="description" :code="code" :can-edit="true" @edit="editDescription" />

      <div class="olap-header">
        <div class="olap-header-title">{{ reportName }}</div>

        <div class="olap-header-actions">
          <responsible v-if="report" class="olap-responsible" :worker="responsible" @assign="assignResponsible" />

          <c-button
            v-if="report"
            class="olap-description"
            size="small"
            :icon="{
              icon: 'comment',
              activeColor: 'white',
            }"
            :tooltip="{
              text: 'Добавить описание',
              activeText: 'Просмотр описания',
            }"
            active-color="blue"
            :active="report.hasDescription"
            @click="report.hasDescription ? showDescription() : addDescription()"
          />

          <c-button-dropdown
            class="olap-actions"
            icon="arrow"
            type="dropdown"
            label="Действия"
            :dropdown="{
              position: 'left',
              items: [
                { icon: 'excel', iconColor: 'success', label: 'Выгрузить в Excel', emit: 'exportToExcel' },
                { icon: 'edit', label: 'Редактировать настройки', emit: 'edit' },
                { icon: 'trash', iconColor: 'secondary', label: 'Удалить', emit: 'remove' },
              ],
            }"
            @exportToExcel="exportToExcel"
            @edit="editReport"
            @remove="removeReport"
          />

          <c-button
            size="small"
            class="olap-list"
            label="К списку отчетов"
            :icon="{
              icon: 'back',
            }"
            :responsive="true"
            @click="$router.push({ name: 'olap', query: { code: code } })"
          />
        </div>
      </div>

      <div class="olap-filters">
        <template v-if="hasPeriodFilter">
          <c-input
            ref="datepicker"
            v-model="form.period"
            class="olap-filters-period"
            placeholder="00.00.0000 - 00.00.0000"
            type="period"
            icon="calendar"
            :icon-right="true"
            :clearable="true"
          />

          <c-button class="olap-filters-apply" label="Показать" color="primary" @click="apply" />
        </template>

        <responsible class="olap-responsible" :worker="responsible" @assign="assignResponsible" />
      </div>

      <div class="olap__actions d-flex justify-content-between">
        <div class="olap__params">
          <c-button
            v-if="switcherLocal !== 'viewing'"
            class="olap-params-show-hide"
            size="small"
            icon="settings"
            :active="isShowFields"
            :label="isShowFields ? 'Скрыть параметры' : 'Показать параметры'"
            responsive
            @click="isShowFields = !isShowFields"
          />
          <!-- <c-button
          class="olap-params-fill"
          @click="isShowHighlightDataModal = true"
          size="small"
          icon="fill"
          label="Подсветка данных"
          responsive/>-->
        </div>

        <div class="d-flex">
          <chat-button
            v-if="report"
            class="olap__comments"
            entity="olap_report"
            :entity-id="reportId"
            :can-edit="!!report.chat"
            :hide-empty="!report.chat"
          />

          <div class="olap__view">
            <c-switcher
              v-model="switcherLocal"
              class="h-switcher"
              type="group"
              :items="[
                { label: 'Настройка', value: 'customization' },
                { label: 'Просмотр', value: 'viewing' },
              ]"
              :disabled="isDataLoading"
            />
          </div>
        </div>
      </div>

      <loader
        v-if="isDataLoading"
        :active="isDataLoading"
        class="couriers-report-table__loader"
        height="500"
        label="Данные загружаются"
      />

      <div v-if="!isDataLoading" class="olap-report">
        <wj-pivot-panel
          id="pivot-panel-fields"
          :class="{ 'olap-wj-panel-hide': !isShowFields || switcherLocal === 'viewing' }"
          :initialized="initPivotPanel"
          class="olap-wj-panel"
          :items-source="ng"
        ></wj-pivot-panel>
        <div
          :class="{
            'olap-report-grid-max-width': switcherLocal === 'viewing' || !isShowFields,
          }"
          class="olap-report-grid"
        >
          <wj-pivot-panel
            v-if="switcherLocal === 'customization'"
            id="pivot-panel-areas"
            class="olap-wj-panel"
            :class="{ 'olap-wj-panel-viewing': switcherLocal === 'viewing' }"
            :items-source="ng"
          >
          </wj-pivot-panel>
          <wj-pivot-grid
            class="olap-wj-grid"
            :style="{
              'max-height': switcherLocal === 'viewing' ? 'calc(100vh - 280px)' : '',
            }"
            :items-source="ng"
            :initialized="initPivotGrid"
          >
          </wj-pivot-grid>
        </div>
        <wj-popup id="wijmoPopup" :initialized="initPopupForm"></wj-popup>
      </div>
      <div v-if="switcherLocal === 'customization'" class="olap-buttons">
        <c-button class="olap-buttons-delete" color="secondary" label="Удалить" @click="removeReport" />
        <c-button class="olap-buttons-cancel" label="Отменить" @click="cancel" />
        <c-button
          class="olap-buttons-save"
          color="primary"
          label="Сохранить"
          @click="isShowSaveOlapReportModal = true"
        />
      </div>
    </template>
  </div>
</template>
<script>
import "@grapecity/wijmo.styles/wijmo.css";
import * as wjCore from "@grapecity/wijmo";
import * as wjcOlap from "@grapecity/wijmo.olap";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";

import "@grapecity/wijmo.touch";
import "@grapecity/wijmo.vue2.core";
import "@grapecity/wijmo.vue2.olap";
import "@grapecity/wijmo.vue2.grid";
import "@grapecity/wijmo.vue2.input";

import Button from "@/components/controls2/Button";
import CButtonDropdown from "@/components/controls/button-dropdown";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import Loader from "@/components/loader";
import Confirm from "@/components/modals/confirm-modal";
import MDescription from "@/components/modals/description-modal";

import { getDatePickerDateValue, yesterday, firstDayCurrentMonth, today } from "@/constants/datePickerSelectVariants";

import HighlightDataModal from "./components/highlight-data-modal";
import SaveOlapReportModal from "./components/save-olap-report-modal";
import MReport from "./components/report-modal";
import Responsible from "./components/responsible";

import { customTemplate } from "./utils/custom-template";
import { OlapReport } from "./models/olap-report";

import ChatButton from "@/components/chat/ChatButton";
import { CALCULATION_REPORT_CODE, REPORT_CODES, WORKERS_REPORT_CODE } from "./utils/codes";
import {
  GET_REPORT_ACTION,
  GET_REPORT_SETTINGS_ACTION,
  REMOVE_REPORT_ACTION,
  SAVE_REPORT_SETTINGS_ACTION,
} from "./utils/actions";

const defaultDatepickerValues = {
  label: "Текущий месяц",
  value: yesterday,
  start: firstDayCurrentMonth,
  end: today,
};

export default {
  name: "olap-report-calculations",
  components: {
    "c-button": Button,
    CButtonDropdown,
    "c-input": Input,
    "c-switcher": Switcher,
    Loader,
    "m-highlight-data-modal": HighlightDataModal,
    "m-save-olap-report": SaveOlapReportModal,
    "m-confirm": Confirm,
    MReport,
    Responsible,
    MDescription,
    ChatButton,
  },
  data() {
    return {
      code: CALCULATION_REPORT_CODE,

      reportId: null,
      report: null,
      noReportError: false,

      loading: false,
      isDataLoading: true,

      form: {
        period: "Вчера",
      },

      isShowFields: true,
      isShowHighlightDataModal: false,
      isShowSaveOlapReportModal: false,
      switcherLocal: "viewing",

      pivotGrid: null,
      ng: null,
      wijmoPopup: {},
      fieldsBlockTopPosition: 0,
    };
  },

  computed: {
    reportName() {
      return this.report && this.report.name;
    },
    responsible() {
      return this.report && this.report.responsible;
    },
    commentsLabel() {
      return "Нет комментариев";
    },

    hasPeriodFilter() {
      return this.code !== WORKERS_REPORT_CODE;
    },
  },

  watch: {
    switcherLocal(value) {
      if (value === "viewing") {
        this.ng.refresh();
      } else {
        this.ng.refresh();
        this.initSearchFields();
        setTimeout(() => {
          this.fieldsBlockTopPosition = document.getElementById("pivot-panel-fields").getBoundingClientRect().top;
        });
      }
    },
  },

  created() {
    const { code } = this.$route.query;
    const { id } = this.$route.params;

    this.reportId = id;

    if (REPORT_CODES.includes(code)) this.code = code;
    wjcOlap.PivotPanel.controlTemplate = customTemplate;
  },

  mounted() {
    this.onMount();
    this.hideTrial();
  },

  methods: {
    getTrial() {
      return document.querySelector("a[href*='grapecity.com/licensing/wijmo']");
    },
    hideTrial() {
      const trialMessage = this.getTrial();
      if (trialMessage) {
        trialMessage.remove();
        return;
      }

      const observer = new MutationObserver((_, observer) => {
        const trialMessage = this.getTrial();
        if (trialMessage) {
          trialMessage.remove();
          observer.disconnect();
        }
      });
      observer.observe(document.body, {
        childList: true,
      });
    },
    async onMount() {
      this.loading = true;

      if (!this.reportId) {
        this.noReportError = true;
      } else {
        await this.loadReportData(this.reportId)
          .then((data) => {
            this.report = data;
            document.title = data.name;
          })
          .catch(() => {
            this.noReportError = true;
          });
      }

      this.loading = false;
      if (!this.noReportError) {
        this.$nextTick(() => {
          this.setFiltersFromQuery();
          this.apply();
        });
      }
    },
    loadReportData(reportId) {
      return this.$store
        .dispatch(GET_REPORT_ACTION, { id: reportId, code: this.code })
        .then((data) => OlapReport(data));
    },
    setFiltersFromQuery() {
      if (!this.hasPeriodFilter) return;
      const { startDate, endDate } = this.$route.query;
      this.setPeriodInput(startDate, endDate);
    },

    setPeriodInput(startDate, endDate) {
      if (!this.hasPeriodFilter) return;
      const datePicker = this.$refs.datepicker;

      if (startDate && startDate.length > 0 && endDate && endDate.length > 0) {
        datePicker.period.start.input = startDate;
        datePicker.period.end.input = endDate;
        datePicker.dateValue = getDatePickerDateValue(startDate, endDate);
      } else {
        datePicker.dateValue = defaultDatepickerValues.label;
        datePicker.period.start.input = defaultDatepickerValues.start;
        datePicker.period.end.input = defaultDatepickerValues.end;
      }
    },

    handleScroll() {
      const layout = document.querySelector(".layout");
      const fieldsBlockElement = document.getElementById("pivot-panel-fields");

      if (!fieldsBlockElement) {
        return;
      }

      const result = layout.scrollTop - this.fieldsBlockTopPosition;

      if (layout.scrollTop > this.fieldsBlockTopPosition) {
        fieldsBlockElement.style.transform = `translateY(${result}px)`;
      } else {
        fieldsBlockElement.style.transform = "none";
      }
    },

    cancel() {
      this.switcherLocal = "viewing";
      this.apply();
    },

    assignResponsible() {
      this.$refs.reportModal.open(this.reportId, "responsible");
    },

    showDescription() {
      this.$refs.description.open(this.report);
    },

    addDescription() {
      this.$refs.reportModal.open(this.reportId, "description");
    },

    editDescription() {
      this.$refs.reportModal.open(this.reportId, "description");
    },

    editReport() {
      this.$refs.reportModal.open(this.reportId);
    },

    onReportUpdated(model) {
      this.report = OlapReport(model);
    },

    removeReport() {
      this.$refs.confirmModal.open({
        title: "Удаление отчета",
        text: `Отчет <b>${this.reportName}</b> будет удален без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          const { reportId } = this;
          this.$store.dispatch(REMOVE_REPORT_ACTION, { reportId, code: this.code }).then(() => {
            this.onReportRemoved(reportId);
          });
        },
      });
    },

    onReportRemoved() {
      this.$router.push({ name: "olap", query: { code: this.code } });
    },

    save(params) {
      const { name, type } = params;
      const id = type === "save_as_new" ? 0 : this.reportId;

      const filters = this.getParams();
      console.log(filters);
      this.ng.fields.forEach((field) => {
        if (!field.subFields) {
          return;
        }
        field.subFields.forEach((subField) => {
        });
      });

      let filterss = {
        startDate: filters.startDate,
        endDate: filters.endDate,
      };
      [...this.ng.columnFields, ...this.ng.rowFields, ...this.ng.valueFields].forEach((field) => {
        if (field.filter.isActive) {
          var cf = field.filter.valueFilter;
          var vf = field.filter.conditionFilter;
          filterss[field.key] = {
            conditionFilter : {isActive: vf.isActive, and: vf.and,
              condition1 : {isActive: vf.condition1.isActive, operator:vf.condition1.operator, value:vf.condition1.value},
              condition2 : {isActive: vf.condition2.isActive, operator:vf.condition2.operator, value:vf.condition2.value},
            },
            filterType : field.filter.filterType,
            valueFilter : {isActive:cf.isActive, showValues:cf.showValues}
          }
          console.log(field.filter);
        }
      })

      if (name) {
        const definition = JSON.parse(this.ng.viewDefinition);
        const params = {
          name,
          id,
          rows: JSON.stringify(definition.rowFields.items),
          columns: JSON.stringify(definition.columnFields.items),
          values: JSON.stringify(definition.valueFields.items),
          code: this.code,
          filters: JSON.stringify(filterss)
        };

        this.$store.dispatch(SAVE_REPORT_SETTINGS_ACTION, params).then((res) => {
          if (res.value.toString() !== this.reportId.toString()) {
            this.$router.push({
              name: "olap-report",
              params: { id: res.value, code: this.code },

              query: {
                startDate: filters.startDate,
                endDate: filters.endDate,
                code: this.code,
              },
            });
            this.$router.go();
            return;
          }

          this.report.name = name;
          this.isShowSaveOlapReportModal = false;

          // this.setPeriodInput(filters.startDate, filters.endDate);
          this.apply();
        });
      }
    },

    exportToExcel() {
      const book = wjcGridXlsx.FlexGridXlsxConverter.saveAsync(this.pivotGrid, {
        includeColumnHeaders: true,
        includeRowHeaders: true,
      });

      book.sheets[0].name = "OLAP Report";

      book.saveAsync(`${this.reportName}.xlsx`);
    },

    fetchData() {
      this.isDataLoading = true;
      let noDate = !this.hasPeriodFilter;
     // console.log(this.$refs.datepicker)

      const params = this.getParams();
      this.setQueryParams(params);
     // this.$refs.datepicker.dateValue = "Вчера";

      this.$store
        .dispatch(GET_REPORT_SETTINGS_ACTION, params)
        .then((res) => {
          if (res.data)
          res.data.map((i)=>{
            if ("calc_datetime" in i){
              let r = /^(\d+)\.(\d+)\.(\d+)$/.exec(i['calc_datetime']);
              i['calc_datetime'] = new Date(r[3], r[2]-1, r[1])
            }
          })

          res.fields.map((i) => i.subFields.map((j) => {
            if (j.binding=="plan_duration" || j.binding=="duration" || j.binding=="worktime") j.format="n2"
          }));
          this.ng = new wjcOlap.PivotEngine({
            fields: res.fields || [],
            itemsSource: res.data || [],
            showRowTotals: "Subtotals",
            valueFields: res.valueFields || [],
            columnFields: res.columnFields || [],
            rowFields: res.rowFields || [],
          });
          this.ng.refresh();
          //this.ng.itemsSource = res.data;
          this.initSearchFields();

            if (noDate) {
              //alert("1");
       //       if (res.filters.startDate) params.startDate = res.filters.startDate;
         //     if (res.filters.endDate) params.endDate = res.filters.endDate;
           //   this.setQueryParams(params);
            }

            if (res.filters) {
              [...this.ng.columnFields, ...this.ng.rowFields, ...this.ng.valueFields].forEach((field) => {
                if (res.filters[field.key]) {
                  var f = res.filters[field.key];
                  var filter = field.filter;
                  filter.filterType = f.filterType;
                  if (f.valueFilter.isActive) {
                    filter.valueFilter.showValues = f.valueFilter.showValues;
                  }
                  if (f.conditionFilter.isActive) {
                    filter.conditionFilter.and = f.conditionFilter.and;
                    if (f.conditionFilter.condition1.isActive) {
                      filter.conditionFilter.condition1.operator=f.conditionFilter.condition1.operator;
                      filter.conditionFilter.condition1.value=f.conditionFilter.condition1.value;
                    }
                    if (f.conditionFilter.condition2.isActive) {
                      filter.conditionFilter.condition2.operator=f.conditionFilter.condition2.operator;
                      filter.conditionFilter.condition2.value=f.conditionFilter.condition2.value;
                    }
                  }
                }
              })
            }
          this.ng.refresh();


          this.initSearchFields();
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },

    apply() {
      this.fetchData();
    },

    getParams() {
      const params = {
        code: this.code,
        report: this.reportId,
        startDate: "",
        endDate: "",
      };

      if (this.hasPeriodFilter) {
        const { start, end } = this.$refs.datepicker.period;
        params.startDate = start.input;
        params.endDate = end.input;
      }

      return params;
    },

    setQueryParams(filters) {
      const { startDate, endDate, code } = filters;
      const { query } = this.$route;

      const newQuery = {
        ...query,
        code,
      };

      if (startDate) {
        newQuery.startDate = startDate;
      } else {
        delete newQuery.startDate;
      }

      if (endDate) {
        newQuery.endDate = endDate;
      } else {
        delete newQuery.endDate;
      }

      if (JSON.stringify(query) !== JSON.stringify(newQuery)) {
        this.$router.push({
          query: newQuery,
        });
      }
    },

    hideFields(panel) {
      this.ng.fields.forEach((field) => {
        field.visible = field.subFields && field.subFields.length ? true : false;
      })
      this.updateGridFields(panel, "[wj-part='d-fields']");
    },

    getGrid(element, seletor) {
      return wjCore.Control.getControl(element.querySelector(seletor));
    },

    updateGridFields(panel, selector) {
      const fldGrid = this.getGrid(panel.hostElement, selector);
      if (fldGrid) {
        fldGrid.loadedRows.addHandler(this.hideRows);
        this.hideRows(fldGrid);
      }
    },

    hideRows(fldGrid) {
      fldGrid.rows.forEach((r) => {
        r.visible = r.dataItem.visible;
      });
    },

    initPivotPanel(panel) {
       this.hideFields(panel);

      document.querySelector(".fields-list-search-wrapper_clear-button").addEventListener("click", () => {
        const searchInputElement = document.getElementById("field-list-search-wrapper-input");
        searchInputElement.value = "";
        this.resetFieldsSearchInput();
      });

      const layoutElement = document.querySelector(".layout");
      layoutElement.addEventListener("scroll", this.handleScroll);
    },

    initPivotGrid(grid) {
      this.pivotGrid = grid;
    },

    randomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },
    initPopupForm(popup) {
      this[popup.hostElement.id] = popup;
    },
    initContextMenuFilter(panel, ng, popUp) {
      const filterEditorsArray = [];
      let filterEditor;

      // Attaching custom contextmenu
      panel.addEventListener(
        "contextmenu",
        (e) => {
          let clickedField;
          e.preventDefault();
          e.stopPropagation();
          if (e.target) {
            clickedField = e.target.textContent;
          }
          for (let i = 0; i < filterEditorsArray.length; i++) {
            if (filterEditorsArray[i].field.key.trim().toLowerCase() === clickedField.trim().toLowerCase()) {
              if (popUp.hostElement.hasChildNodes()) popUp.hostElement.removeChild(popUp.hostElement.firstChild);
              popUp.hostElement.appendChild(filterEditorsArray[i].hostElement);
              popUp.show(true);
            }
          }
        },
        true,
      );

      // Creating PivotFilterEditor for each field
      ng.fields.forEach((field) => {
        if (!field.subFields) {
          return;
        }
        field.subFields.forEach((subField) => {
          filterEditor = new wjcOlap.PivotFilterEditor(document.createElement("div"), subField);
          filterEditorsArray.push(filterEditor);
        });
      });

      // Adding cancel button and click event on cancel, ok button
      filterEditorsArray.forEach((filterEditor) => {
        const okBtn = filterEditor.hostElement.firstChild.lastChild.firstChild;
        const cancelBtn = document.createElement("button");
        Object.assign(cancelBtn, {
          className: "wj-btn",
          textContent: "Cancel",
        });
        Object.assign(cancelBtn.style, {
          fontSize: "12px",
          marginLeft: "10px",
        });
        filterEditor.hostElement.firstChild.lastChild.appendChild(cancelBtn);

        // Attaching click handler to cancel button
        okBtn.addEventListener("click", () => {
          filterEditor.updateFilter();
          // wjCore.hidePopup(filterEditor.hostElement);
          this.wijmoPopup.hide();
        });

        // Attaching click handler to ok button
        cancelBtn.addEventListener("click", (e) => {
          e.cancel = true;
          // wjCore.hidePopup(filterEditor.hostElement);
          this.wijmoPopup.hide();
        });
      });
    },
    resetFieldsSearchInput() {
      const noMatchedFieldElement = document.querySelector(".fields-list-search-no-fields-found");
      const clearButtonElement = document.querySelector(".fields-list-search-wrapper_clear-button");

      this.ng.fields.forEach((field) => {
        field.visible = field.subFields && field.subFields.length ? true : false;
        if (field.subFields) {
          field.subFields.forEach((fl) => {
            fl.visible = true;
          });
        }
      });

      noMatchedFieldElement.classList.add("d-none");
      clearButtonElement.classList.add("d-none");
    },
    initSearchFields() {
      if (this.switcherLocal === "viewing") {
        return;
      }
      setTimeout(() => {
        const pivotAreas = document.getElementById("pivot-panel-areas");
        this.initContextMenuFilter(pivotAreas, this.ng, this.wijmoPopup);

        const searchElement = document.getElementById("field-list-search-wrapper-input");
        const noMatchedFieldElement = document.querySelector(".fields-list-search-no-fields-found");
        const clearButtonElement = document.querySelector(".fields-list-search-wrapper_clear-button");

        const vm = this;
        searchElement.addEventListener("keyup", function () {
          const searchValue = this.value.toLowerCase();
          clearButtonElement.classList.remove("d-none");
          if (searchValue.length > 0) {
            vm.ng.fields.forEach((field) => {
              let isGroupSearchNotResult = false;
              if (field.subFields) {

                field.subFields.forEach((fl) => {
                  //console.log(<fl className="isActive"></fl>);
                  if (fl.isActive || fl.key.toLowerCase().includes(searchValue)) {
                    isGroupSearchNotResult = true;
                    fl.visible = true;
                  } else {
                    fl.visible = fl.isActive
                  }
                });
              }
              if (!isGroupSearchNotResult) {
                field.visible = false;
              }
            });
            let noMatchedField = true;
            vm.ng.fields.forEach((field) => {
              if (!noMatchedField) {
                return;
              }
              if (field.visible) {
                noMatchedField = false;
              }
              if (field.subFields) {
                noMatchedField = !field.subFields.some((subField) => subField.visible);
              }
            });
            if (noMatchedField) {
              noMatchedFieldElement.classList.remove("d-none");
            }
            vm.ng.refresh();
          } else {
            vm.resetFieldsSearchInput();
          }
        });

        const pivotFields = document.getElementById("pivot-panel-fields");
        this.initContextMenuFilter(pivotFields, this.ng, this.wijmoPopup);
      }, 250);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.olap {
  padding: 39px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  .no-report {
    margin-top: 20px;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      font-weight: 500;
      font-size: 22px;
      line-height: 108%;
    }

    &-actions {
      display: flex;
      align-items: center;
      margin-left: 20px;
    }

    /deep/ {
      .c-button__dropdown__container {
        max-width: none;
        white-space: nowrap;
      }
    }

    .olap-responsible,
    .olap-description,
    .olap-actions {
      margin-right: 10px;
    }

    .olap-responsible {
      display: none;
    }
  }

  &__actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__comments {
    margin-left: 10px;
  }

  &__view {
    margin-left: 10px;
    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  &-filters {
    display: flex;
    align-items: flex-end;
    margin-top: 29px;

    &-report-format {
      min-width: 267px;

      @media screen and (max-width: 800px) {
        min-width: initial;
      }
    }

    &-period {
      min-width: 267px;

      /deep/ {
        .c-input-container {
          left: 0;
          transform: none;
        }
      }

      @media screen and (max-width: 800px) {
        min-width: initial;
      }
    }

    &-apply {
      max-width: 115px;
      margin-left: 30px;
    }

    .olap-responsible {
      margin-left: auto;
    }
  }

  @include bootstrapLg {
    &[data-code="worker"] {
      .olap-filters {
        display: none;
      }
    }
    &-filters {
      .olap-responsible {
        display: none;
      }
    }
    &-header {
      .olap-responsible {
        display: block;
      }
    }
  }

  &-params {
    display: flex;
    margin-top: 31px;

    @media screen and (max-width: 992px) {
      display: none;
    }

    &-fill {
      margin-left: 8px;
    }
  }

  &-report {
    margin-top: 30px;
    display: flex;

    &-grid {
      display: flex;
      transition: all 0.5s;
      flex-direction: column;
      width: 100%;
      margin-left: 10px;
      max-width: calc(100% - 397px);

      &-max-width {
        margin-left: 0;
        max-width: 100% !important;
      }

      @media screen and (max-width: 1300px) {
        max-width: calc(100% - 280px);
      }

      @media screen and (max-width: 992px) {
        max-width: 100%;
        margin-left: 0;
      }
    }
  }

  &-buttons {
    max-width: 1160px;
    margin-left: 370px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 1300px) {
      margin-left: 310px;
    }

    @media screen and (max-width: 992px) {
      display: none;
    }

    &-delete {
      max-width: 107px;
    }

    &-cancel {
      max-width: 118px;
      margin-left: 10px;
    }

    &-save {
      margin-left: 10px;
      max-width: 124px;
    }
  }
}
.wj-content {
  border: 1px solid #dfe4ef;

  ::v-deep & .wj-glyph-up,
  ::v-deep & .wj-glyph-down {
    color: #0066ff;
  }

  ::v-deep & .wj-cell {
    border-right: 1px solid #dfe4ef;
    border-bottom: 1px solid #dfe4ef;
  }

  ::v-deep & .wj-row-field-hdr,
  ::v-deep & .wj-colheaders .wj-row .wj-header {
    background: #ffffff;
    font-size: 12px;
    font-weight: 500;
    color: #8e9cbb;
    line-height: 108%;
    padding: 8px 12px;
  }

  ::v-deep & .wj-rowheaders {
    font-weight: 500;
    font-size: 13px;
    line-height: 100%;
  }

  ::v-deep & .wj-rowheaders .wj-row .wj-header {
    background: #f5f7fa;
  }

  ::v-deep & .wj-cells {
    font-size: 13px;
    /* max-height: 500px !important;
    overflow-y: auto;*/
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/vars";
.olap-wj-grid {
  margin-top: 10px;
  max-width: 100%;
  max-height: 720px;
  width: fit-content;

  &-max-height {
    max-height: calc(100vh - 220px) !important;

    @media screen and (max-width: 992px) {
      max-height: calc(100vh - 280px) !important;
    }
  }

  & div div::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: white;
    cursor: pointer;
    z-index: 300;
    position: relative;
  }

  & div div::-webkit-scrollbar-thumb {
    background: $color-secondary;
    //border-radius: 12px;
    border-radius: 10px;
    background-clip: padding-box;
    //border: 10px solid #fff;
  }

  & div div::-webkit-scrollbar-track {
    background: #dfe4ef;
    width: 6px;
    border-radius: 10px;
    z-index: 300;
    position: relative;

    @media (max-width: 992px) {
      display: none;
    }
  }
}
.olap-wj-grid .wj-aggregate {
  background: #e1edff !important;
}
.olap-wj-grid .wj-aggregate.wj-cell {
  font-weight: 400 !important;
}
.olap-wj-grid .wj-rowheaders .wj-cell.wj-header {
  background: #f5f7fa !important;
  font-weight: 500 !important;
}
.olap-wj-grid .wj-header.wj-col-field-hdr {
  color: #8e9cbb !important;
  background: #ffffff !important;
}
.olap-wj-grid .wj-colheaders .wj-cell.wj-header {
  background: #ffffff !important;
}
.olap-wj-grid .wj-cells .wj-aggregate.wj-header {
  background: #ffffff !important;
}

.olap-wj-panel {
  @media screen and (max-width: 992px) {
    flex-wrap: wrap;
  }

  &::-webkit-scrollbar {
    width: 24px;
    height: 24px;
    background: white;
    border: 1px solid #dfe4ef;
    cursor: pointer;
    z-index: 300;
    position: relative;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 12px;
    background-clip: padding-box;
    border: 10px solid #fff;
  }

  &::-webkit-scrollbar-track {
    background: $color-border-alt;
    width: 4px;
    background: white;
    z-index: 300;
    position: relative;
  }
}

.olap-wj-panel-hide {
  visibility: hidden;
  opacity: 0;
  min-width: 0 !important;
  width: 0 !important;
  transition: all 0.5s linear;
}

.olap-wj-panel .wj-control .wj-content .wj-pivotpanel {
  border: none !important;
}

#pivot-panel-areas {
  max-width: 1160px;
  max-height: 240px;
  border: solid 1px #dfe4ef !important;
  width: 100%;

  @media screen and (max-width: 992px) {
    display: none;
    max-height: initial;
  }

  & .fields-list-search-wrapper {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
    background: white;
    cursor: pointer;
    z-index: 300;
    position: relative;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 10px;
    background-clip: padding-box;
    border: none !important;
  }

  &::-webkit-scrollbar-track {
    background: #dfe4ef;
    width: 6px !important;
    border-radius: 10px;
    z-index: 300;
    position: relative;

    @media (max-width: 992px) {
      display: none;
    }
  }
}
.pivot-panel-areas-hidden {
  max-height: 0 !important;
  visibility: hidden;
  opacity: 0;
}
#pivot-panel-fields {
  max-width: 387px;
  min-width: 387px;
  /*max-height: 600px;*/
  width: 100%;

  @media screen and (max-width: 1300px) {
    min-width: 280px;
    max-width: 280px;
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
}

#pivot-panel-areas .field-list {
  display: none !important;
}

#pivot-panel-fields .filter-list {
  display: none;
}
#pivot-panel-fields .column-list {
  display: none;
}
#pivot-panel-fields .row-list {
  display: none;
}
#pivot-panel-fields .values-list {
  display: none;
}
#pivot-panel-fields .wj-btn.wj-btn-glyph.wj-elem-collapse {
  z-index: 10 !important;
}

.filter-list {
  display: none;
}
.olap-wj-grid {
  //max-height: 753px;
}
.olap-wj-grid .wj-cell {
  padding: 12px 10px;
  font-family: Fira Sans;
  font-size: 13px;
  line-height: 100%;
}

.wj-cell.wj-header {
  font-weight: 500 !important;
}

.wj-control {
  border: none !important;
}
.wj-pivotpanel {
  min-height: auto;
  padding: 0;
}
.wj-pivotpanel .wj-flexgrid {
  margin-left: 0;
}
.field-list {
  width: 100%;
  max-width: 387px;
  height: 93vh;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #dfe4ef;
  position: sticky;
  top: 0;

  @media screen and (max-width: 1300px) {
    max-width: 300px;
  }

  &::-webkit-scrollbar,
  & div div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background: white;
    cursor: pointer;
    z-index: 300;
    position: relative;
  }

  &::-webkit-scrollbar-thumb,
  & div div::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 10px;
    background-clip: padding-box;
    //border: 3px solid #fff;
  }
  &::-webkit-scrollbar-track,
  & div div::-webkit-scrollbar-track {
    background: #dfe4ef;
    border-radius: 10px;
    width: 5px;
    z-index: 300;
    position: relative;
  }
}
.field-list .wj-row span {
  //display: none!important;
}
.field-list .wj-cell {
  border-right: none !important;
  border-bottom: none !important;
}
.field-list .wj-glyph-dimension,
.field-list .wj-glyph-measure {
  display: none;
}
.field-list .wj-group,
.field-list .wj-group label {
  display: flex;
  align-items: center;
  line-height: 120%;
}
.field-list .wj-group label input {
  width: 15px;
  height: 15px;
  margin-right: 10px !important;
}
.field-list .wj-cell.wj-group {
  background: #ffffff !important;
}
.field-list .wj-cells .wj-cell.wj-state-selected {
  color: black !important;
}
.field-list .wj-header {
  font-size: 15px;
  position: relative;
  line-height: 108%;
}

.fields-list-search-wrapper {
  display: flex;
  align-items: center;
  width: calc(100% - 24px) !important;
  padding: 9px 0;
  margin: 0 auto 10px 12px;
  border-bottom: solid 1px #dfe4ef;

  &_clear-button {
    fill: $color-secondary;
    cursor: pointer;
  }
}
.fields-list-search-wrapper input {
  margin-left: 13px;
  border: none;
  display: flex;
  flex-grow: 1;
  outline: none;
}
.fields-list-search-wrapper input::placeholder {
  font-size: 13px;
  line-height: 108%;
  color: #8e9cbb;
  font-style: italic;
}

.filter-list,
.column-list,
.row-list,
.values-list {
  max-width: 288px;
  padding: 14px 12px;
  border: 1px solid #dfe4ef;

  @media screen and (max-width: 992px) {
    max-width: 50%;
    width: 50%;
  }
}
.filter-list .wj-cell,
.column-list .wj-cell,
.row-list .wj-cell,
.values-list .wj-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px !important;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 50px;
  padding-bottom: 6px;
  font-family: Fira Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 108%;
  color: #000000;
  border: 1px solid #d3d8df !important;
  margin-bottom: 5px;
}

.filter-list .wj-cell:hover,
.column-list .wj-cell:hover,
.row-list .wj-cell:hover,
.values-list .wj-cell:hover {
  border-radius: 50px !important;
}

.filter-list-label,
.column-list-label,
.row-list-label,
.values-list-label {
  display: inline-block;
  font-family: Fira Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #000000;
  margin-bottom: 8px !important;
}
.filter-list-label:first-letter,
.column-list-label:first-letter,
.row-list-label:first-letter,
.values-list-label:first-letter {
  text-transform: uppercase;
}

.filter-list,
.column-list,
.row-list,
.values-list {
  border-left: none;
  border-top: none;
  border-bottom: none;
}

.column-list {
  @media screen and (max-width: 992px) {
    border-right: none;
  }
}

.row-list {
  @media screen and (max-width: 992px) {
    border-top: 1px solid #dfe4ef;
  }
}

.values-list {
  border-right: none;

  @media screen and (max-width: 992px) {
    border-top: 1px solid #dfe4ef;
  }
}

.wj-pivotgrid {
  border: 1px solid #dfe4ef !important;
  border-right: none !important;
  border-bottom: none !important;
}

.wj-glyph-filter {
  color: #0066ff !important;
  opacity: 1 !important;
}
.wj-marker {
  height: 5px !important;
  background: #0066ff !important;
  border-radius: 50px;
  opacity: 1 !important;
}
.progress-bar {
  display: none !important;
}
.fields-list-search-no-fields-found {
  font-size: 15px;
  margin-left: 11px;
  color: $color-label;
}
.wj-pivotpanel .wj-flexgrid {
  max-height: unset !important;
}
</style>
